import { Molenda2007Link, Morrison2013Link } from '../../common/links'

const data = {
  titleMain: 'Management of Web 2.0 Tools',
  // titleSecondary: '',
  courseNumber: 'EDET 746',
  projectLink:
    'https://drive.google.com/file/d/1akBl75typSZeMykTeY-eM7RImt9bfTSK/view?usp=sharing',
  // projectLink2: '',
  standardName: 'AECT 5 – Research',
  standardSummary:
    'Candidates explore, evaluate, synthesize, and apply methods of inquiry to enhance learning and improve performance.',
  contextAndConditions:
    'During the Fall 2020 Management of Technology Resources (EDET 746) course with Dr. Gary Senn, we studied the organization and administration of media programs in various educational environments, with emphasis on procedures, problems, and trends for an integrated instructional support system.',
  scope:
    'For this research paper, I examined the use of Web 2.0 tools, specifically wikis and blogs, in health professions education. In the paper, I discussed advantages and disadvantages for each of the Web 2.0 tools and guidelines for managing appropriate use.',
  role:
    'Working independently on this project, I served as subject matter expert, instructional designer and developer. After researching the use of various Web 2.0 tools in my career area, I analyzed the two that I found to be most beneficial and developed suggestions for how to appropriately manage the use of both tools.',
  instructionalDesign: `Following ADDIE (${Molenda2007Link}) and MRK (${Morrison2013Link}) instructional design models, I first analyzed research related to Web 2.0 tools in health professions education. From the analysis, I chose to focus on wikis and blogs and then designed an outline of the research paper with a listing of advantages and disadvantages for both tools. Following this outline, I developed the research paper and asked a work colleague to review the draft, using her suggestions for improvements to finalize the research paper.`,
  performanceIndicator: [
    // Each of these sections in between the {} represents a new bullet point in the list
    {
      title: 'Theoretical Foundations',
      indicator:
        'Candidates demonstrate foundational knowledge of the contribution of research to the past and current theory of educational communications and technology.',
      implementation:
        'I completed extensive research on the use and impact of Web 2.0 tools in health professions education, examining the advantages and disadvantages in order to develop recommendations for appropriate use.',
    },
    {
      title: 'Method',
      indicator:
        'Candidates apply research methodologies to solve problems and enhance practice.',
      implementation:
        'I performed a thorough literature review of the use and impact of Web 2.0 tools in health professions education, focusing on articles published within the past 5 years, in order to narrow my topic to two specific tools to research further.',
    },
    {
      title: 'Assessing/Evaluating',
      indicator:
        'Candidates apply formal inquiry strategies in assessing and evaluating processes and resources for learning and performance.',
      implementation:
        'From my research and reading, I developed guidelines for managing appropriate use of wikis and blogs in health professions education.',
    },
    {
      title: 'Ethics',
      indicator:
        'Candidates conduct research and practice using accepted professional and institutional guidelines and procedures.',
      implementation: 'Resources and references were appropriately cited.',
    },
  ],
  reflection:
    'Having already written a few research papers at this point in the training program, I was more familiar with the research and writing process, so this artifact demonstrates more advanced application of knowledge and skills. I enjoyed exploring the advantages and disadvantages of incorporating Web 2.0 tools into my health professions education and carefully considering whether wikis and blogs would be appropriate for use in my specific professional work. I look forward to analyzing and incorporating other current and emerging collaborative online tools into my professional practice.',
}

export default data
